var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9074 21.86C9.89411 21.7666 8.89411 21.3 8.12078 20.4866C6.36078 18.6333 6.36078 15.5933 8.12078 13.74L11.0408 10.6733C12.8008 8.81999 15.6941 8.81999 17.4675 10.6733C19.2275 12.5267 19.2275 15.5667 17.4675 17.42L16.0141 18.9533",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0949 11.14C22.1082 11.2333 23.1082 11.7 23.8815 12.5133C25.6415 14.3667 25.6415 17.4067 23.8815 19.26L20.9615 22.3267C19.2015 24.18 16.3082 24.18 14.5348 22.3267C12.7748 20.4733 12.7748 17.4333 14.5348 15.58L15.9882 14.0467",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 29.8333H20.0013C26.668 29.8333 29.3346 27.1667 29.3346 20.5V12.5C29.3346 5.83332 26.668 3.16666 20.0013 3.16666H12.0013C5.33464 3.16666 2.66797 5.83332 2.66797 12.5V20.5C2.66797 27.1667 5.33464 29.8333 12.0013 29.8333Z",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcons);
export default __webpack_public_path__ + "static/media/linkIcons.e52fddd1.svg";
export { ForwardRef as ReactComponent };